import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import moment from "moment";

import VitalTableCard from "../UI/VitalTableCard";
import { usePatient } from "../../context/PatientContext";
import { listTemperatureVital } from "../../HTTPS/VitalApis";
import ReuseableModel from "../Modals/ReuseableModel";
import TempEditVitalForm from "../Forms/TempEditVitalForm";
import { formatDate, formatTime } from "../../utils/chartUtils";

function TemperatureTable() {
  const [open, setOpen] = useState(false);
  const [entry, setEntry] = useState({});
  const { patient } = usePatient();

  const { data, isLoading } = useQuery({
    queryKey: ["TempVitalList", patient?.id],
    queryFn: () => listTemperatureVital(patient?.providerUserId),
    enabled: !!patient?.id,
    refetchOnWindowFocus: false,
  });

  if (isLoading) {
    return (
      <div className="w-full p-3 bg-black/40 rounded-lg text-center text-white text-lg">
        {<p>Loading...</p>}
      </div>
    );
  }

  data?.sort((a, b) => {
    if (moment(a.date).isSame(b.date)) {
      return a.id < b.id ? 1 : -1; // because seconds are not there so we are comparing SQL id
    } else {
      return moment(a.date).isBefore(b.date) ? 1 : -1;
    }
  });

  return (
    <>
      <VitalTableCard
        valOne="°F"
        date="Date"
        time="Time"
        isButtonHeading="Edit"
      />
      {data?.map((i) => (
        <VitalTableCard
          valOne={i.temperature}
          date={formatDate(i?.date)}
          time={formatTime(i?.date)}
          onClick={() => {
            setOpen(true);
            setEntry(i);
          }}
          createdBy={i?.createdBy}
        />
      ))}
      <ReuseableModel open={open} setOpen={setOpen}>
        <TempEditVitalForm setOpen={setOpen} entry={entry} />
      </ReuseableModel>
    </>
  );
}

export default TemperatureTable;
